import styled from 'styled-components'

export default styled.div`
  display: inline-block;
  margin-right: 20px;
  margin-bottom: 15px;
`
